import type MailListLogsStore from './schema/MailListLogsStore';

export const mailListLogsStore: MailListLogsStore = {
    mailListLogs: [],
};
